<div class="row mt-2" #containerRef2>
    <div class="col-12">
        <h6 style="color: #126db3;margin-left: 20px;">
            {{"action_plan.statistics.states" | translate}}
        </h6>
    </div>
    <div class="col-12" style="margin-top:40px">
        <ngx-charts-pie-chart [results]="estados" [view]="[containerRef2.offsetWidth - 35, 290]" [legend]="true"
            [legendPosition]="'below'" [legendTitle]="title" [scheme]="colorSchema" [labels]="false">
        </ngx-charts-pie-chart>
    </div>

</div>